import { Licensing_V1 } from "@rw1/auto-generated-clients";
import type {
  HistoricalLicense,
  HistoricalSeatAllocation,
} from "../models/license";

export const toHistoricalLicense = (
  license: Licensing_V1.HistoricalLicense,
): HistoricalLicense => ({
  licenseId: license.licenseId,
  releaseChannelId: license.releaseChannelId,
  contentMetadataId: license.contentMetadataId,
  licenseName: license.licenseName,
  issuingOrganizationId: license.issuingOrganizationId,
  assignedOrganizationId: license.assignedOrganizationId,
  startDate: license.startDate,
  endDate: license.endDate,
});

export const toHistoricalSeatAllocation = (
  allocation: Licensing_V1.HistoricalLicenseUserAllocation,
): HistoricalSeatAllocation => ({
  licenseAllocationId: allocation.licenseAllocationId,
  licenseId: allocation.licenseId,
  licenseName: allocation.licenseName,
  userId: allocation.userId,
  createdAt: allocation.createdAt,
  originalExpiresAt: allocation.originalExpiresAt,
  expiresAt: allocation.expiresAt,
  assignedOrganizationId: allocation.assignedOrganizationId,
});
